<template>
  <v-row no-gutters>
    <v-row no-gutters class="ma-3">
      <v-checkbox
        v-for="(checkbox, checkboxIndex) in checkboxOptions"
        :key="checkboxIndex"
        v-model="selectedCheckboxs[checkbox.value]"
        :label="checkbox.label"
        :disabled="checkbox.disabled"
        color="third"
        class="mr-4"
        hide-details
      />
    </v-row>
    <v-col cols="12">
      <TextField
        v-model="sessionsToCreate[index].name"
        subtitle="Nom de la Session *"
        :rules="mandatoryRule"
        :single-line="true"
      />
    </v-col>
    <v-col :cols="isSessionStage ? 6 : 12">
      <DatePicker v-model="sessionsToCreate[index].date" title="Date de la session *" icon="mdi-clock" :clickable-icon="true" />
    </v-col>
    <v-col :cols="isSessionStage ? 6 : 12" align-self="center">
      <Button
        v-if="isSessionStage"
        icon="mdi-plus"
        class="d-flex align-center font-weight-bold d-flex  justify-center font-weight-bold full-height ma-auto"
        :outlined="true"
        label="Ajouter une période"
        :remove-margin="true"
        color="third"
        :large="true"
        :icon-color="null"
        :plain="true"
        :action="addNewTime"
      />
    </v-col>
    <v-col v-if="isSessionStage" cols="12">
      <div class="col-12">
        <v-row v-for="(period,periodIndex) in sessionsToCreate[index].periods" :key="periodIndex" class="col-12">
          <v-col cols="4" class="d-flex justify-end align-center text-subtitle-1">
            Période {{ periodIndex+1 }}
          </v-col>
          <v-col cols="6" class="pr-0">
            <SessionTimesForm
              :start-time.sync="period.start"
              :end-time.sync="period.end"
              :date="selectedDate"
            />
          </v-col>
          <v-col class="d-flex align-center">
            <Button
              icon="mdi-close"
              class="d-flex align-center font-weight-bold d-flex  justify-center full-height"
              :outlined="false"
              :setfullheight="true"
              :remove-margin="true"
              :color="null"
              :icon-color="null"
              :plain="true"
              :action="() => removePeriod(periodIndex)"
            />
          </v-col>
        </v-row>
      </div>
    </v-col>
    <v-col v-if="isSessionStage ? !(sessionsToCreate[index].periods || []).length : true" cols="6" class="d-inline-block">
      <SelectPicker
        v-model="sessionsToCreate[index].startTimeHelper"
        subtitle="Début *"
        :items="computedStartTime"
        :rules="mandatoryRule"
        :clear-value="false"
        :have-error="haveError"
      />
    </v-col>
    <v-col v-if="isSessionStage ? !(sessionsToCreate[index].periods || []).length : true" cols="6" class="d-inline-block">
      <SelectPicker
        v-model="sessionsToCreate[index].endTimeHelper"
        subtitle="Fin *"
        :items="computedEndTime"
        :rules="mandatoryRule"
        :clear-value="false"
        :have-error="haveError"
      />
    </v-col>
  </v-row>
</template>

<script>
import { inject, computed, watch, onBeforeMount, ref } from '@vue/composition-api';

import { format, fromUnixTime, getUnixTime } from 'date-fns';
import { startTimeOptions, endTimeOptions } from '@/helpers/dataManager';
import { mandatoryRule } from '@/helpers/utils';
import { addPeriodToSessionPeriodArray, sessionHaveError, sessionsWithPeriods, canCopyHorses } from '@/helpers/sessions';

import DatePicker from '@/components/common/Form/DatePicker.vue';
import SelectPicker from '@/components/common/Form/SelectPicker.vue';
import TextField from '@/components/common/Form/TextField.vue';

import Button from '@/components/common/Button.vue';

import SessionTimesForm from '@/components/sessions/createForm/SessionTimesForm';

export default {
  components: { DatePicker, SelectPicker, TextField, Button, SessionTimesForm },
  props: {
    index: {
      type: Number,
      default: -1
    }
  },
  setup (props) {
    const sessionsToCreate = inject('sessionsToCreate');
    const selectedCheckboxs = inject('selectedCheckboxs');

    const computedStartTime = computed(() => startTimeOptions());
    const computedEndTime = computed(() => endTimeOptions());

    const isSessionStage = computed(() => sessionsWithPeriods.includes(sessionsToCreate.value[props.index].type));

    const addNewTime = () => {
      sessionsToCreate.value[props.index].periods = addPeriodToSessionPeriodArray(sessionsToCreate.value[props.index]);
    };

    const removePeriod = periodIndexToRemove => {
      sessionsToCreate.value[props.index].periods.splice(periodIndexToRemove, 1);
    };

    const haveError = computed(() => sessionHaveError(sessionsToCreate.value[props.index]));

    const selectedDate = computed(() => format(fromUnixTime(sessionsToCreate.value[props.index].date), 'yyyy-MM-dd'));

    const sessionDate = computed(() => sessionsToCreate.value[props.index].date);

    const checkboxOptions = ref([
      { label: 'Copier les participants', value: 'copyParticipants', disabled: false },
      { label: 'Copier les moniteurs', value: 'copyInstructors', disabled: false },
      { label: 'Copier les chevaux', value: 'copyHorses', disabled: !canCopyHorses.includes(sessionsToCreate.value[props.index].type) }
    ]);

    const computeNewSessionperiods = () => {
      sessionsToCreate.value[props.index].periods = sessionsToCreate.value[props.index].periods.map(p => {
        p.start = getUnixTime(new Date(`${format(fromUnixTime(sessionDate.value), 'yyyy-MM-dd')}T${format(fromUnixTime(p.start), 'HH:mm')}`));
        p.end = getUnixTime(new Date(`${format(fromUnixTime(sessionDate.value), 'yyyy-MM-dd')}T${format(fromUnixTime(p.end), 'HH:mm')}`));

        return p;
      });
    };

    watch(sessionDate, () => {
      computeNewSessionperiods();
    });

    onBeforeMount(() => {
      computeNewSessionperiods();
    });

    return { selectedDate, removePeriod, sessionsToCreate, computedStartTime, computedEndTime, mandatoryRule, isSessionStage, addNewTime, haveError, checkboxOptions, selectedCheckboxs };
  }
};

</script>
